(() => {
  if (window.__mobileCartFeedbackInit) return;
  window.__mobileCartFeedbackInit = true;

  const MOBILE_QUERY = '(max-width: 767px)';
  const POPUP_MESSAGE = 'Produto adicionado ao carrinho.';
  const MAX_AGE_MS = 7000;

  const state = {
    lastButton: null,
    lastAt: 0,
    armed: false
  };

  const ensureStyles = () => {
    if (document.getElementById('mobile-cart-feedback-styles')) return;
    const style = document.createElement('style');
    style.id = 'mobile-cart-feedback-styles';
    style.textContent = `
      .bottom-popup {
        position: fixed;
        left: 50%;
        bottom: 12px;
        z-index: 9000;
        max-width: min(90vw, 360px);
        padding: 12px 18px;
        border-radius: var(--btn-border-radius);
        background: rgb(var(--body-bg-color));
        color: rgb(var(--body-text-color));
        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.16);
        text-align: center;
        transform: translate(-50%, 130%);
        opacity: 0;
        transition: transform 0.35s ease, opacity 0.35s ease;
      }
      .bottom-popup--visible {
        transform: translate(-50%, 0);
        opacity: 1;
      }
      @media (min-width: 768px) {
        .bottom-popup {
          display: none;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;

  const showBottomPopup = () => {
    if (!isMobile()) return;
    ensureStyles();
    const existing = document.querySelector('.bottom-popup');
    if (existing) existing.remove();

    const popup = document.createElement('div');
    popup.className = 'bottom-popup';
    popup.textContent = POPUP_MESSAGE;
    document.body.appendChild(popup);

    requestAnimationFrame(() => {
      popup.classList.add('bottom-popup--visible');
    });

    setTimeout(() => {
      popup.classList.remove('bottom-popup--visible');
    }, 2600);
    setTimeout(() => {
      popup.remove();
    }, 3300);
  };

  const arm = (button) => {
    state.lastButton = button;
    state.lastAt = Date.now();
    state.armed = true;
  };

  const isFresh = () => state.armed && (Date.now() - state.lastAt) < MAX_AGE_MS;

  const consume = () => {
    if (!state.armed) return null;
    const button = state.lastButton;
    state.lastButton = null;
    state.lastAt = 0;
    state.armed = false;
    return button;
  };

  const handleCartFeedback = () => {
    if (!isFresh()) return;
    consume();
    showBottomPopup();
  };

  document.addEventListener('submit', (evt) => {
    const form = evt.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('.product-card-atc-form, .js-product-form')) return;
    const button = form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]');
    arm(button);
  }, true);

  document.addEventListener('click', (evt) => {
    const button = evt.target.closest('[name="add"], .add-to-cart');
    if (!button) return;
    const form = button.closest('.product-card-atc-form, .js-product-form');
    if (!form) return;
    arm(button);
  }, true);

  document.addEventListener('on:cart:add', handleCartFeedback);
  document.addEventListener('on:cart:change', handleCartFeedback);


  if (!window.__mobileCartFeedbackFetchWrapped && window.fetch) {
    window.__mobileCartFeedbackFetchWrapped = true;
    const originalFetch = window.fetch.bind(window);
    window.fetch = (...args) => {
      const request = args[0];
      const url = typeof request === 'string' ? request : (request && request.url);
      const isCartAdd = url && url.indexOf('/cart/add') !== -1;
      return originalFetch(...args).then((response) => {
        if (isCartAdd && response && response.ok) {
          const cloned = response.clone();
          cloned.json()
            .then((data) => {
              if (data && data.status) return;
              handleCartFeedback();
            })
            .catch(() => {
              handleCartFeedback();
            });
        }
        return response;
      });
    };
  }
})();
